import React from 'react';
interface SubBrandCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  href?: string;
}
export function SubBrandCard({
  title,
  description,
  icon,
  href = '#'
}: SubBrandCardProps) {
  return <a href={href} className="group block relative p-8 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl hover:border-blue-200 transition-all duration-300 overflow-hidden" data-id="element-58">
      {/* Hover background effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-59" />

      <div className="relative z-10" data-id="element-60">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-slate-50 text-slate-700 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300 mb-6" data-id="element-61">
          {icon}
        </div>

        <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors duration-300" data-id="element-62">
          {title}
        </h3>

        <p className="text-slate-600 leading-relaxed" data-id="element-63">{description}</p>

        <div className="mt-6 flex items-center text-sm font-semibold text-blue-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300" data-id="element-64">
          Learn more
          <svg className="ml-1 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-65">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-66" />
          </svg>
        </div>
      </div>
    </a>;
}